import { getBusinessSubTypeLabel } from "@/utils";
import React from "react";

const BusinessDetail = ({
  businessData,
  setIsModalOpen,
  setShowStripe,
  setCurrentStep,
}) => {
  return (
    <div className="max-w-4xl mx-auto p-4 md:p-8 bg-white rounded-xl shadow-xl">
      {/* Title Section */}

      {/* Business Info */}
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
        <div className="flex flex-col space-y-2">
          <span className="text-sm text-gray-600">Name</span>
          <span className="text-base font-medium text-gray-800">
            {businessData?.name}
          </span>
        </div>
        <div className="flex flex-col space-y-2">
          <span className="text-sm text-gray-600">Type</span>
          <div className="flex flex-wrap gap-2">
            {(Array.isArray(businessData?.type)
              ? businessData.type
              : [businessData?.type]
            ).map(
              (type, idx) =>
                type && (
                  <span
                    key={idx}
                    className="text-sm font-medium bg-gray-100 text-gray-800 px-3 py-1 rounded-full"
                  >
                    {getBusinessSubTypeLabel(type)}
                  </span>
                )
            )}
          </div>
        </div>
        <div className="flex flex-col space-y-2">
          <span className="text-sm text-gray-600">Hours of Operation</span>
          <span className="text-base font-medium text-gray-800">
            {businessData?.operational_hrs}
          </span>
        </div>
        <div className="flex flex-col space-y-2">
          <span className="text-sm text-gray-600">Phone Number</span>
          <span className="text-base font-medium text-gray-800">
            {businessData?.phone}
          </span>
        </div>
        <div className="flex flex-col space-y-2">
          <span className="text-sm text-gray-600">Address</span>
          <span className="text-base font-medium text-gray-800">
            {businessData?.address}
          </span>
        </div>
        <div className="flex flex-col space-y-2">
          <span className="text-sm text-gray-600">City</span>
          <span className="text-base font-medium text-gray-800">
            {businessData?.city}
          </span>
        </div>
        <div className="flex flex-col space-y-2">
          <span className="text-sm text-gray-600">State</span>
          <span className="text-base font-medium text-gray-800">
            {businessData?.state}
          </span>
        </div>
        <div className="flex flex-col space-y-2">
          <span className="text-sm text-gray-600">Country</span>
          <span className="text-base font-medium text-gray-800">
            {businessData?.country}
          </span>
        </div>
        <div className="flex flex-col space-y-2">
          <span className="text-sm text-gray-600">Airport</span>
          <span className="text-base font-medium text-gray-800">
            {businessData?.airport}
          </span>
        </div>
        <div className="flex flex-col space-y-2">
          <span className="text-sm text-gray-600">Website</span>
          <a
            href={businessData?.url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#8ec639] text-lg font-medium hover:underline"
          >
            {businessData?.url}
          </a>
        </div>
        {businessData?.discounts && businessData?.discounts?.length > 0 && (
          <div className="flex flex-col space-y-2">
            <span className="text-sm text-gray-600">Discounts</span>
            <ul className="pl-0">
              {businessData?.discounts?.map((discount, idx) => (
                <li key={idx} className="text-base font-medium text-gray-800">
                  {discount?.title}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>

      {/* Action Buttons */}
      <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-end">
        <button
          className="w-full sm:w-auto px-6 py-3 bg-[#af2322] text-white font-medium rounded-lg hover:bg-[#9e1f1a] transition"
          onClick={() => setCurrentStep(2)}
        >
          Next
        </button>
      </div>

      {/* Edit Link */}
      <div className="mt-6 text-center text-sm text-gray-500">
        Need to edit?{" "}
        <button
          className="text-[#8ec639] hover:underline"
          onClick={() => {
            setIsModalOpen(false);
            setShowStripe(false);
            setCurrentStep(1);
          }}
        >
          Go back to form
        </button>
      </div>
    </div>
  );
};

export default BusinessDetail;
